import { inject, observer } from 'mobx-react'
import React, { ChangeEvent } from 'react'
import { RouteComponentProps } from 'react-router'
import { withStateCard, CardTitle, Card, CardContent, Input, Toast, ToastType, TutorialButtonAndBackButton } from '../../Components';
import DetalhesAlunoCard from './Components/DetalhesAlunoCard'
import { AlunoStore, ALUNO_STORE, PROFESSOR_STORE, ProfessorStore, ProfessorModel, MONOGRAFIA_STORE, MonografiaStore} from '../../Store'
import styled from 'styled-components';
import { format } from 'date-fns';
import AlterarOrientadorModal from './Components/AlterarOrientadorModal';
import AlterarNotaModal from './Components/AlterarNotaModal';
import Tutorial_Funcionario from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Funcionario.pdf";

interface IProps extends RouteComponentProps<{ id: string }> {
    [ALUNO_STORE]: AlunoStore;
    [PROFESSOR_STORE]: ProfessorStore;
    [MONOGRAFIA_STORE]: MonografiaStore;
}

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 10px;
`;

const StyledInput = styled(Input) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn}
`;

const StyledText = styled.span`
  padding: 5px;
`;

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const DetalhesAlunoPageWithState = withStateCard(Container);

@inject(ALUNO_STORE, PROFESSOR_STORE, MONOGRAFIA_STORE)
@observer
export default class DetalhesAlunoPage extends React.Component<IProps> {

    state = {notaOValida: true, notaCValida: true};

    constructor(props: IProps) {
        super(props);
    }

    componentDidMount() {
        const id = Number(this.props.match.params.id);
        const store = this.props[ALUNO_STORE];
        store.getAluno(id);

        const professorStore = this.props[PROFESSOR_STORE]
        professorStore.getProfessores();   
        
        const monografiaStore = this.props[MONOGRAFIA_STORE]
        monografiaStore.getMonografiaDoAluno(id);
    }

    ativarDesativar = async () => {
        const alunoStore = this.props[ALUNO_STORE];
        await alunoStore.ativarDesativarUmAluno();
    }

    getSituacaoAluno(sit: string) {
        switch (sit) {
            case "C":
                return "Cadastrado";
            case "F":
                return "Formado";
            case "P":
                return "Promovido";
            case "R":
                return "Retido";
            case "V":
                return "Vago";
            case "T":
                return "Trancado";
            default:
                return "Matriculado"
        }
    }

    onResumeClick = () => {
        window.open(Tutorial_Funcionario);
    }

    handleOrientadoresSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const id = Number(e.target.value)
        const professorStore = this.props[PROFESSOR_STORE];    
        const { professores } = professorStore;
        const monografiaStore = this.props[MONOGRAFIA_STORE];

        if (id == 0) {
             monografiaStore.updateAttribute('professor', new ProfessorModel())
        } else {  
            monografiaStore.updateAttribute('professor', professores.find(p => p.id == id))
        }
    }

    handleTextSelectChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target
        const monografiaStore = this.props[MONOGRAFIA_STORE];   
        monografiaStore.updateAttribute(name, value)
    }

    handleAutorizacaoSelectChange = (value: any) => {
        const monografiaStore = this.props[MONOGRAFIA_STORE];
        monografiaStore.update('monografia', 'autorizacaoProfessor', value);
      }

    aprovarPreProjeto = async (monografiaId: number, professorId: number) => {
        const monografiaStore = this.props[MONOGRAFIA_STORE];
        const { setValidationError } = monografiaStore

        setValidationError({});
        await monografiaStore.editarOrientadorMonografiaDoAluno(monografiaId, professorId)
    }

    alterarNota = async (monografiaId: number, notaO: number|undefined, 
        notaC: number|undefined,
        obs: string|undefined,
        aut: boolean|undefined) => {
        const monografiaStore = this.props[MONOGRAFIA_STORE];
        const { setValidationError } = monografiaStore

        setValidationError({});

        await monografiaStore.editarNotaMonografiaDoAluno(monografiaId,notaO,notaC,obs,aut)
        window.location.reload();
    }

    render() {
        const alunoStore = this.props[ALUNO_STORE]
        const professorStore = this.props[PROFESSOR_STORE]
        const monografiaStore = this.props[MONOGRAFIA_STORE]
        const { aluno, alunoState } = alunoStore;
        const { history } = this.props;
        const { professores, professoresState } = professorStore;
        const { monografiaState, professor } = monografiaStore;
        const { notaOValida, notaCValida } = this.state;
        const setNotaOValida = (notaOValida: boolean) => this.setState({ notaOValida });
        const setNotaCValida = (notaCValida: boolean) => this.setState({ notaCValida });

        const handleNotaOSelectChange = (event: ChangeEvent<HTMLInputElement>) => {
            const { name, value } = event.target
            const value2 = value.replace(',','.')
            const formattedValue = Number(value2)
            setNotaOValida((/^[0-9]*(\,|\.)?[0-9]*$/.test(value2) || /^\d+$/.test(value2))
            && formattedValue <= 10 && formattedValue >= 0)
            const monografiaStore = this.props[MONOGRAFIA_STORE];   
            monografiaStore.updateAttribute(name, formattedValue)
        }

        const handleNotaCSelectChange = (event: ChangeEvent<HTMLInputElement>) => {
            const { name, value } = event.target
            const value2 = value.replace(',','.')
            const formattedValue = Number(value2)
            setNotaCValida((/^[0-9]*(\,|\.)?[0-9]*$/.test(value2) || /^\d+$/.test(value2))
            && formattedValue <= 10 && formattedValue >= 0)
            const monografiaStore = this.props[MONOGRAFIA_STORE];   
            monografiaStore.updateAttribute(name, formattedValue)
        }

        return (
            <DetalhesAlunoPageWithState
                state={alunoState && professoresState && monografiaState}
                loading='Carregando...'
            >
                <TutorialButtonAndBackButton
                    openTutorial={this.onResumeClick}
                    voltar={() => history.push('/funcionario')}
                />
                <DetalhesAlunoCard aluno={aluno} ativarOuDesativar={this.ativarDesativar} />
                {aluno && !aluno.alunoAtivo &&
                    <Toast type={ToastType.error}>
                        <StyledText>
                            ALUNO DESATIVADO.
                            <hr></hr>
                            Situação: <strong>{this.getSituacaoAluno(aluno.sit)}</strong>
                        </StyledText>
                    </Toast>}
                <Card>
                    {aluno && aluno.monografia ?
                        <>
                            <CardTitle>TCC</CardTitle>
                            <CardContent>
                                <StyledContainer>
                                    <StyledInput
                                        value={aluno.monografia.titulo}
                                        label='Título'
                                        disabled={true}
                                    />
                                    <StyledInput
                                        value={aluno.monografia.professor.nome}
                                        label='Orientador'
                                        disabled={true}
                                    />
                                    {aluno.monografia.deposito &&
                                        <StyledInput
                                            value={format(aluno.monografia.deposito.dataDoDeposito, 'DD/MM/YYYY')}
                                            label='Data do Depósito'
                                            disabled={true}
                                        />}
                                    {aluno.monografia.agendamento &&
                                        <StyledInput
                                            value={format(aluno.monografia.agendamento.dataInicio, 'DD/MM/YYYY')}
                                            label='Data da Apresentação'
                                            disabled={true}
                                        />}
                                    {(aluno.monografia.nota || aluno.monografia.nota == 0) &&
                                        <StyledInput
                                            value={aluno.monografia.nota}
                                            label='Nota atribuída a monografia:'
                                            disabled={true}
                                        />}
                                </StyledContainer>
                            </CardContent>                           
                        </> :
                        <CardContent><strong>Aluno sem Monografia</strong></CardContent>
                    }
                </Card>
                {aluno && aluno.monografia &&
                <AlterarOrientadorModal
                        monografia={aluno.monografia}
                        professores={professores}
                        onSelectChange={this.handleOrientadoresSelectChange}
                        orientador={professor}
                        onAprovar={this.aprovarPreProjeto}
                    />}
                {aluno && aluno.monografia &&
                <AlterarNotaModal
                        monografia={aluno.monografia}
                        onTextChange={handleNotaOSelectChange}
                        onTextNCChange={handleNotaCSelectChange}
                        onTextObsChange={this.handleTextSelectChange}
                        onAutorizacaoChange={this.handleAutorizacaoSelectChange}
                        onAprovar={this.alterarNota}
                        notaOValida={notaOValida}
                        notaCValida={notaCValida}
                    />}
            </DetalhesAlunoPageWithState>
        )
    }
}